import * as React from "react";
import type { SVGProps } from "react";

const SvgInsoles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={1672}
    height={2058}
    viewBox="0 0 1672 2058"
    {...props}
  >
    <defs>
      <style>
        {`.cls-1 {
                    fill: none;
                    stroke: #142745;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-width: 70px;
                }`}
      </style>
    </defs>
    <path
      className="cls-1"
      d="M1019.4,1301.5s6.5-149.1-35.1-231.1c-60.2-118.7-15.4-337.7,70.3-471.6,0,0,112-171.3,252.5-96.6,0,0,254.7,142.7,43.9,757.6,0,0-32.9,97.6-63.7,122.3l-267.9-80.6h0Z"
    />
    <path
      className="cls-1"
      d="M993.1,1405.6l272.3,82.6s-15.4,239.4-158.1,309.6c0,0-141.1,60.1-198.1-115.5,0,0-34.3-105.4,83.9-276.7h0Z"
    />
    <path
      className="cls-1"
      d="M594,1078.8s25.6-147,83.7-218.2c84.2-103.1,87.2-326.6,32.2-475.8,0,0-72.8-191.3-226-148.4,0,0-279.4,85-204.9,730.7,0,0,11.3,102.3,36,133.1l278.9-21.5h0Z"
    />
    <path
      className="cls-1"
      d="M597.5,1186.1l-283.7,22.4s-36.2,237.1,88.2,336.3c0,0,124.9,88.9,218.2-70.5,0,0,56.1-95.6-22.8-288.2h0Z"
    />
  </svg>
);
export default SvgInsoles;
